<template>
    <div style="display: flex">
        <div>
            <div>
                <el-select
                    v-model="keywords"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    :clearable="true"
                    size="mini"
                    @change="currentSelect"
                    style="width: 500px;margin-bottom: 10px"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                        class="one-text"
                    >
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{
                                item.district
                            }}</span>
                    </el-option>
                </el-select>
            </div>
            <div id="container" class="container"></div>
        </div>
        <div class="info-box">
            <el-form :model="form" ref="position" :rules="rules" label-width="80px" size="mini" :inline="true">
                <el-form-item label="地理纬度" prop="lat">
                    <el-input style="width: 200px" size="small" disabled v-model='form.lat'></el-input>
                </el-form-item>
                <el-form-item label="地理经度" prop="lat">
                    <el-input style="width: 200px" size="small" disabled v-model='form.lng'></el-input>
                </el-form-item>
                <el-form-item label="省" prop="province">
                    <el-select
                        placeholder="请选择省"
                        clearable
                        style="width: 200px"
                        size="small"
                        v-model="form.province"
                    >
                        <el-option
                            v-for='(item,index) in areaTreeDate'
                            :key='index'
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="市" prop="city">
                    <el-select
                        placeholder="请选择市"
                        clearable
                        style="width: 200px"
                        size="small"
                        v-model="form.city"
                    >
                        <el-option
                            v-for='(item,index) in cityIdList'
                            :key='index'
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区" prop="area">
                    <el-select
                        placeholder="请选择区"
                        clearable
                        style="width: 200px"
                        size="small"
                        v-model="form.area"
                    >
                        <el-option
                            v-for='(item,index) in areaIdList'
                            :key='index'
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="社区" prop="street" v-if="form.province != 1 && form.province != 2 && form.province != 3 && form.province != 4">
                    <el-select
                        placeholder="请选择社区"
                        clearable
                        style="width: 200px"
                        size="small"
                        v-model="form.street"
                    >
                        <el-option
                            v-for='(item,index) in streetIdList'
                            :key='index'
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input
                        type="textarea"
                        style="width: 200px"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        placeholder="请输入内容"
                        v-model="form.address">
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { WEB_JS_KEY,SECURITY_JS_CODE } from '@/utils/constant'
import { get } from '@/utils/request.js';

window._AMapSecurityConfig = {
    // 安全密钥
    securityJsCode: SECURITY_JS_CODE,
};
export default {
    name: "TestIndex",
    data() {
        return {
            // 地图实例
            map: null,
            // 标记点
            marker: "",
            // 地址逆解析
            geoCoder: null,
            // 搜索提示
            AutoComplete: null,
            // 搜索关键字
            keywords: "",
            // 位置信息
            form: {
                lng: "",
                lat: "",
                address: "",
                province: "",
                city: "",
                area: "",
                street: ''
            },
            // 搜索节流阀
            loading: false,
            // 搜索提示信息
            options: [],
            rules:{
                lng: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                lat: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                province: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                city: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                area: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                street: [{ required: true, message: '社区不能为空', trigger: 'blur' }],
            },
            expands: [],

            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: true,//区别是不是get来的
            getArea: true,//区别是不是get来的
            street: true,
        };
    },
    props:{
        areaTreeDate:{
            type: Array,
            default: []
        },
        longitude:{
            type: String,
            default: ''
        },
        latitude:{
            type: String,
            default: ''
        },
        provinceId:{
            type: String,
            default: ''
        },
        cityId:{
            type: String,
            default: ''
        },
        areaId:{
            type: String,
            default: ''
        },
        address:{
            type: String,
            default: ''
        },
        streetId:{
            type: String,
            default: ''
        },
    },
    watch:{
        //市
        'form.province'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.form.city = '';
                    this.form.area = '';
                    this.form.street = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'form.city'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.form.area = '';
                    this.form.street = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'form.area'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.form.street = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
    },
    methods: {
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        initMap() {
            AMapLoader.load({
                // 你申请的Key
                key: WEB_JS_KEY,
                version: "2.0",
                // 需要用到的插件
                plugins: ["AMap.Geocoder", "AMap.AutoComplete"],
            })
                .then((AMap) => {
                    //地址逆解析插件
                    this.geoCoder = new AMap.Geocoder({
                        city: "010", //城市设为北京，默认：“全国”
                        radius: 1000, //范围，默认：500
                    });
                    if(this.longitude == '' && this.latitude == ''){
                        this.map = new AMap.Map("container", {
                            viewMode: "3D", //是否为3D地图模式
                            zoom: 5, //初始化地图级别
                            center: [117.192561, 31.831908], //初始化地图中心点位置
                        });
                    } else {
                        this.map = new AMap.Map("container", {
                            viewMode: "3D", //是否为3D地图模式
                            zoom: 18, //初始化地图级别
                            center: [this.form.lng, this.form.lat], //初始化地图中心点位置
                        });

                        // 清除点
                        this.removeMarker();
                        // 标记点
                        this.setMapMarker();
                    }

                    // 搜索提示插件
                    this.AutoComplete = new AMap.AutoComplete({ city: "全国" });
                    //点击获取经纬度;
                    this.map.on("click", (e) => {
                        // 获取经纬度
                        this.form.lng = e.lnglat.lng;
                        this.form.lat = e.lnglat.lat;
                        // 清除点
                        this.removeMarker();
                        // 标记点
                        this.setMapMarker();
                    });
                })
                .catch((err) => {
                    // 错误
                    console.log("加载地图失败");
                    console.log(err);
                });
        },
        // 标记点
        setMapMarker() {
            // 自动适应显示想显示的范围区域
            this.map.setFitView();
            this.marker = new AMap.Marker({
                map: this.map,
                position: [this.form.lng, this.form.lat],
            });
            // 逆解析地址
            this.toGeoCoder();
            this.map.setFitView();
            this.map.add(this.marker);
        },
        // 清除点
        removeMarker() {
            if (this.marker) {
                this.map.remove(this.marker);
            }
        },
        // 逆解析地址
        toGeoCoder() {
            let lnglat = [this.form.lng, this.form.lat];
            console.log(this.geoCoder,"????")
            this.geoCoder.getAddress(lnglat, (status, result) => {
                if (status === "complete" && result.regeocode) {
                    this.form.address = result.regeocode.formattedAddress;
                    console.log('result',result)
                }
            });
        },
        // 搜索
        remoteMethod(query) {
            console.log(query);
            if (query !== "") {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.AutoComplete.search(query, (status, result) => {
                        this.options = result.tips;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        // 选中提示
        currentSelect(val) {
            // 清空时不执行后面代码
            console.log("?????????",val)
            if (!val) {
                return;
            }
            this.form = {
                lng: val.location.lng,
                lat: val.location.lat,
                address: val.district + val.address,
                province: "",
                city: "",
                area: "",
            };
            // 清除点
            this.removeMarker();
            // 标记点
            this.setMapMarker();
        },
        sendForm(){
            this.$refs.position.validate((valid) => {
                if(valid){
                    this.$emit('getPosition',this.form)

                    this.form = {
                        lng: "",
                        lat: "",
                        address: "",
                        province: "",
                        city: "",
                        area: "",
                        street: ""
                    };
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                }
            })
        },
        clearSubitem(id){
            if (id === 'province'){
                this.form.city = ""
                this.form.area = ""
                this.form.street = ""
            } else if (id === 'city') {
                this.form.area = ""
                this.form.street = ""
            }else if(id === "area"){
                this.form.street = ""
            }
        },
        initialize(){
            console.log('this.form',this.form)
            this.form.province = this.provinceId
            this.form.city = this.cityId
            this.form.area = this.areaId
            this.form.street = this.streetId
            this.form.address = this.address
            this.form.lng = this.longitude == '' ? null : parseFloat(this.longitude)
            this.form.lat = this.latitude == '' ? null : parseFloat(this.latitude)


            this.initMap();
        }
    },
    mounted() {
        console.log("2",this.longitude,this.latitude)
        this.initMap();
    },
};
</script>

<style>
.container {
    width: 500px;
    height: 300px;
}
</style>